import { GET_DATA_SEARCH, SAVE_SEARCH_VALUE, RESET_SEARCH } from "../constants";
import { SearchBang } from "../../services/search";
import { message } from "antd";
import Cookies from "js-cookie";

export const searchBang = (payload) => async (dispatch) => {
  try {
    const res = await SearchBang(payload.params);
    if (res) {
      const { data } = res.data;

      dispatch({
        type: GET_DATA_SEARCH,
        payload: data,
      });

      return data;
    }
  } catch (error) {
    if (["Cookie hết hạn", "Sai captcha"].includes(error.response.data)) {
      Cookies.remove("code");
      payload.callback();
      return null;
    }
    message.error('Có lỗi xảy ra, vui lòng thử lại!');
  }
};

export const saveSearchValue = (payload) => (dispatch) => {
  dispatch({
    type: SAVE_SEARCH_VALUE,
    payload,
  });
};

export const resetSearchValue = (payload) => (dispatch) => {
  dispatch({
    type: RESET_SEARCH,
    payload,
  });
};
